import { Injectable } from '@angular/core';
import { ElectionService } from './election.service';

export type HaPartyId = 'LIB' | 'ALP' | 'IND';

export interface HaSeatsWonByPartyId {
  LIB: number;
  ALP: number;
  IND: number;
}

@Injectable({
  providedIn: 'root',
})
export class HaSeatsWonDataService {
  constructor(private electionService: ElectionService) {}

  /**
   * Reads statewide House of Assembly seat totals for the given election date
   * from the electionMap (DB-backed via ElectionService).
   *
   * Returns null if electionCount hasn't been built yet for that date.
   */
  public getSeatsWonByPartyId(electionDateString: string): HaSeatsWonByPartyId | null {
    const election = this.electionService.electionMap.get(electionDateString);
    const parties = election?.electionCount?.parties;
    if (!parties) return null;

    const get = (partyId: HaPartyId): number => {
      const row = parties.find((p: any) => String(p.partyId ?? '').toUpperCase() === partyId);
      return Math.trunc(Number(row?.leadingDistrictSeatCount ?? 0));
    };

    return {
      LIB: get('LIB'),
      ALP: get('ALP'),
      IND: get('IND'),
    };
  }
}

